import fileDownload from 'js-file-download';
import * as K from '../../constants/k';
import AndroidFileManger from './AndroidFileManger';
import IosFileManger from './IosFileManger';

export default function DownloaderHandler(snapshotsOnboarding) {
  this.androidFileManger = new AndroidFileManger(this, snapshotsOnboarding);
  this.iosFileManger = new IosFileManger(this, snapshotsOnboarding);

  this.handleExporting = async (exportOptions, configurations) => {
    if (exportOptions.forAndroid) {
      await this.androidFileManger.exportFiles(configurations, exportOptions);
    }
    if (exportOptions.forIOS) {
      await this.iosFileManger.exportFiles(configurations, exportOptions);
    }
  };

  this.exportXML = (configurationsXml, fileName) => {
    fileDownload(configurationsXml, fileName);
  };

  this.exportJSON = (configurationsJson, fileNamePrefix) => {
    fileDownload(JSON.stringify(configurationsJson, null, 2), `${fileNamePrefix}.json`);
  };

  this.exportImage = (imageUri, fileNamePrefix) => {
    const index = imageUri.indexOf(',');
    if (index !== -1) {
      const fileType = K.IMAGE_MIME_TYPE;
      const imageBase64 = imageUri.substring(index + 1);
      const imageBinary = atob(imageBase64);

      const ab = new ArrayBuffer(imageBinary.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < imageBinary.length; i += 1) {
        ia[i] = imageBinary.charCodeAt(i);
      }
      const newBlob = new Blob([ab], { type: fileType });
      fileDownload(newBlob, `${fileNamePrefix}.${K.IMAGE_FILE_EXT}`);
    }
  };

  this.exportFont = (fontUri, fileNamePrefix, fileType) => {
    const index = fontUri.indexOf(',');
    if (index !== -1) {
      const fontBase64 = fontUri.substring(index + 1);
      const fontBinary = atob(fontBase64);

      const ab = new ArrayBuffer(fontBinary.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < fontBinary.length; i += 1) {
        ia[i] = fontBinary.charCodeAt(i);
      }
      const newBlob = new Blob([ab], { type: fileType });
      fileDownload(newBlob, fileNamePrefix);
    }
  };

  this.exportFile = (file, fileName) => {
    fileDownload(file, fileName);
  };
}
